import { gsap, Power4,Expo,Bounce,Back,ScrollToPlugin,ScrollTrigger,TimelineMax,Linear} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin,ScrollTrigger);
const spW = 768;
let userAgent = navigator.userAgent;

(function(){
    const menu = document.getElementsByClassName('js-menu')[0];
    const body = document.getElementsByTagName('body')[0];
    const movieButton = document.getElementsByClassName('js-movie-button');
    const movieModal = document.getElementsByClassName('js-movie-modal')[0];
    const movie = document.getElementsByClassName('js-movie')[0];
    let scrollButton = document.querySelectorAll('a[href^="#"]');
    for(var i = 0;i < scrollButton.length;i++) {
        scrollButton[i].addEventListener('click',(e)=>{
            e.preventDefault();
            let href = e.currentTarget.getAttribute('href'),
                target = document.getElementById(href.replace('#','')),
                top = target.getBoundingClientRect().top,
                offset = window.pageYOffset,
                position = href === '#Top' ? top + offset : top + offset - getHeight(target);
                gsap.to(window,{
                    duration: 1,
                    ease: Power4.easeOut,
                    scrollTo: {
                      y: position,
                      autoKill: false
                    }
                  });
        },false);
    }

    let setMovieButton = () => {
        for(let l = 0; l < movieButton.length ; l++) {
            movieButton[l].addEventListener('click',(e) => {
                e.preventDefault();
                let id = e.currentTarget.getAttribute('data-youtube-id');
                openMovieModal(id);
            });
        }
    }

    let openMovieModal = (id) => {
        let src = 'https://www.youtube.com/embed/' + id + '?showinfo=0&rel=0&amp;controls=1&amp;showinfo=0&iv_load_policy=3'

        movieModal.classList.add('show');
        gsap.to(movieModal,{
            opacity:1,
            duration: 0.3,
            ease: Linear
        });
        gsap.fromTo('.modal__item',{
            scale: 0.3
        },{
            scale: 1,
            duration: 0.5,
            ease: Expo.easeOut
        });
        movie.setAttribute('src',src);
        movieModal.addEventListener('click',closeMovieModal);
    }

    let closeMovieModal = (e) => {
        movieModal.removeEventListener('click',closeMovieModal);
        movie.setAttribute('src','');

        gsap.to(movieModal,{
            opacity:0,
            duration:0.3,
            ease: Linear,
            onComplete: () => {
                movieModal.classList.remove('show');
            }
        });


        //movieModal.classList.remove('show');

    }

    let getHeight = (target) => {
        const isHeight = target.classList.contains('is-height');
        let result = target.classList.contains('section--w');
        let h = 0;
        body.classList.remove('menu-open');
        if(window.innerWidth <= spW) {
            if(result || isHeight) h = 50;
            else h = 0;

        } else {
            if(result || isHeight) h = 90;
            else h = -20;

        }
        return h;

    }

    //scrolltrigger
    let fadeinTarget = document.getElementsByClassName('js-fadein');
    for(var i = 0;i<fadeinTarget.length;i++) {
        //let name = 'js-fadein-' + (i + 1);
        //fadeinTarget[i].classList.add(name);
        gsap.to(fadeinTarget[i],{
            y: 0,
            opacity: 1,
            duration: 1.5,
            ease: Expo.easeOut,
            scrollTrigger: {
                trigger: fadeinTarget[i],
                start: 'top 80%'

            }
        })
    }

    window.addEventListener('load',() => {
        let tl1 = new TimelineMax();
        tl1.to('.js-hero-title',{
            duration: 0.5,
            scale: 1,
            delay: 1,
            ease: Bounce.easeOut
        }).to('.js-hero-title',{
            duration: 0.5,
            opacity: 1,
            delay: -0.5
        });





        /*let tl2 = new TimelineMax();
        const delay = 4,
              duration = 2;
        tl2.to('.js-hero-img-1',{
            scale: 1.1,
            duration: delay + duration
        })
        .to('.js-hero-img-2',{
            opacity: 1,
            duration: duration,
            delay: -duration
        })
        .to('.js-hero-img-2',{
            scale: 1.1,
            duration: delay + duration
        })
        .to('.js-hero-img-3',{
            opacity: 1,
            duration: duration,
            delay: -duration
        });*/

        let hash = window.location.hash;
        if(hash !== "") {
            let target = document.getElementById(hash.replace('#','')),
                top = target.getBoundingClientRect().top,
                offset = window.pageYOffset,
                position = hash === '#Top' ? top + offset : top + offset - getHeight(target);
                setTimeout(() => {
                    window.scrollTo(0,position);
                },1)


        }


        //220713追加動画再生
       // openMovieModal('ebom-Q0Ocjw');


    });


    let pagetop = document.getElementsByClassName('pagetop')[0];

    window.addEventListener('scroll',(e) => {
        if(window.scrollY >= 200) {
            pagetop.classList.add('show');
        }else {
            pagetop.classList.remove('show');

        }

    });
    setMovieButton();


    menu.addEventListener('click',()=>{
        body.classList.toggle('menu-open');

    });

    //IEの場合Twitterを削除
    if(userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident/') > -1) {
        body.classList.add('ie');
    }


})();

//SHARE YELL
(() => {
    const current = document.querySelector('.js-shareyell-content').dataset.init;
    const image = document.querySelectorAll('.js-shareyell-image');
    const button = document.querySelectorAll('.js-shareyell-button');
    let imageNum = 0;

    gsap.set('.js-shareyell-image',{opacity:0});

    const setShareYell = (n) => {
        if(imageNum === n) return;
        imageNum = n;
        button.forEach((el)=> {
            el.classList.remove('current');
        });
        button[n-1].classList.add('current');
        gsap.to('.js-shareyell-image',{
            opacity:0,
            duration: 0.3,
            onComplete: ()=>{
                let loadComp = 0;
                for(let i = 1;i<=4;i++) {
                    const img = new Image();
                    const src = `assets/images/img_shareyell_${n}_${i}.jpg`;
                    img.onload = () => {
                        image[i-1].setAttribute('src',src);
                        loadComp++;
                        if(loadComp >= 4) {
                            gsap.fromTo('.js-shareyell-image',{
                                y: 10,
                                opacity:0
                            },
                            {
                                y: 0,
                                opacity: 1,
                                duration: 0.3,
                                delay: 0.1,
                                stagger: {
                                    each: 0.1
                                }
                            })
                        }
                    }
                    img.src = src;
                }

            }
        })
    }

    button.forEach((el) => {
        el.addEventListener('click',(e)=>{
            e.preventDefault();
            const id = el.dataset.image;
            setShareYell(id);
        })

    });

    setShareYell(current);

})();